import { UploadModel } from '../models/view/Upload';
import { UploadContainerModel } from '../models/view/UploadContainer';
import { StoredFileModel } from '../models/view/StoredFile';
import { BasicPersistenceService } from './BasicPersistenceService';

export class UploadPersistenceService extends BasicPersistenceService<BasicAppDefinition> {

	constructor(options: BasicAppOptions<BasicAppDefinition>) {
		super(options);
		this.applicationSessionKey = 'application.upload';
	}

	public getUploadModelFromStore(): UploadModel {
		const dataObject = T.Utils.Store.get(this.applicationSessionKey, T.Utils.Store.SESSION);
		return UploadModel.createFromObject(dataObject);
	}

	public setUploadModelToStore(uploadModel: UploadModel): void {
		T.Utils.Store.set(this.applicationSessionKey, uploadModel, T.Utils.Store.SESSION);
	}

	public clearUploadModel(): void {
		T.Utils.Store.set(this.applicationSessionKey, null, T.Utils.Store.SESSION);
	}

	public updateUploadContainerStore(containerId: string): void {
		const containerElem = this.options.$ctx.find(`#${containerId}`);
		const upload = this.getUploadModelFromStore();

		if (upload.UploadContainer[containerId] && upload.UploadContainer[containerId].Files) {

			upload.UploadContainer[containerId].Files.forEach(element => {
				if (containerElem.find(`.js-data.is-active.js-file-stored[data-js-guid="${element.FileGuid}"]`).length === 0) {
					let foundFile = -1;
					if (upload.UploadContainer[containerId].Files.some((file, index) => {
						if (file.FileGuid === element.FileGuid) {
							foundFile = index;
							return true;
						}
						return false;
					}) && foundFile > -1) {
						const file = upload.UploadContainer[containerId].Files[foundFile];
						upload.FileSizeSum -= file.FileSize;
						upload.FileCounter--;
						upload.UploadContainer[containerId].Files.splice(foundFile, 1);
					}
				}
			});
			this.setUploadModelToStore(upload);
		}
	}

	public setUploadedFileToStore($fileElem: JQuery, guid: string): void {
		const uploadContainerId = $fileElem.closest('.js-upload-container').attr('id');
		let upload = this.getUploadModelFromStore();

		if (!upload) {
			upload = new UploadModel();
		}

		if (!upload.UploadContainer) {
			upload.UploadContainer = {};
		}
		if (!upload.UploadContainer[uploadContainerId]) {
			upload.UploadContainer[uploadContainerId] = new UploadContainerModel();
		}

		if (!upload.UploadContainer[uploadContainerId].Files) {
			upload.UploadContainer[uploadContainerId].Files = [];
		}


		const file = new StoredFileModel();
		file.FileGuid = guid;
		file.FileName = $fileElem.text();
		file.FileSize = parseInt($fileElem.attr('data-js-filesize') ?? '0');
		if (upload.FileSizeSum === undefined) {
			upload.FileSizeSum = 0;
		}
		upload.FileSizeSum += file.FileSize;
		upload.FileCounter++;

		upload.UploadContainer[uploadContainerId].Files.push(file);

		this.setUploadModelToStore(upload);
	}
}
